import type { RouteRecordRaw } from "vue-router";

export const warehouseManageRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/warehouseManage/productManage",
		name: "WarehouseProductManage",
		meta: {
			title: "产品管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/warehouseManage/productManage/productList",
		children: [
			{
				path: "/desktopCenter/warehouseManage/productManage/productList",
				name: "WmsProductList",
				meta: {
					title: "产品列表",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/WarehouseManage/ProductManage/ProductList/ProductList.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/warehouseManage/warehouseManage",
		name: "WarehouseManageMain",
		meta: {
			title: "仓库管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/warehouseManage/warehouseManage/warehouseManage",
		children: [
			{
				path: "/desktopCenter/warehouseManage/warehouseManage/warehouseManage",
				name: "WarehouseManage",
				meta: {
					title: "仓库管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/WarehouseManage/WarehouseManage/WarehouseManage.vue"
					),
			},
			{
				path: "/desktopCenter/warehouseManage/warehouseManage/reservoirAreaManage",
				name: "ReservoirAreaManage",
				meta: {
					title: "库区管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/WarehouseManage/ReservoirAreaManage/ReservoirAreaManage.vue"
					),
			},
			{
				path: "/desktopCenter/warehouseManage/warehouseManage/locationManage",
				name: "LocationManage",
				meta: {
					title: "库位管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/WarehouseManage/LocationManage/LocationManage.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/warehouseManage/inventoryManage",
		name: "InventoryManageMain",
		meta: {
			title: "库存管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/warehouseManage/warehouseManage/warehouseManage",
		children: [
			{
				path: "/desktopCenter/warehouseManage/inventoryManage/WarehousingManage",
				name: "WarehousingManage",
				meta: {
					title: "入库管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/InventoryManage/WarehousingManage/WarehousingManage.vue"
					),
			},
			{
				path: "/desktopCenter/warehouseManage/inventoryManage/outboundManage",
				name: "OutboundManage",
				meta: {
					title: "出库管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/InventoryManage/OutboundManage/OutboundManage.vue"
					),
			},
			{
				path: "/desktopCenter/warehouseManage/inventoryManage/inventoryManage",
				name: "InventoryManage",
				meta: {
					title: "库存管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/WarehouseManage/InventoryManage/InventoryManage/InventoryManage.vue"
					),
			},
		],
	},
];
